export { routerReducer as routing } from 'react-router-redux';
export { authReducer as auth } from './auth/reducer';
export { createAccountReducer as registration } from './create-account/reducer';
export { profileReducer as profile } from './profile/reducer';
export { jobsReducer as jobs } from './jobs/reducer';
export { jobTypesReducer as jobTypes } from './job_types/reducer';
export { languagesReducer as languages } from './languages/reducer';
export { toggleReducer as toggle } from './toggle/reducer';



/** WEBPACK FOOTER **
 ** ./src/state/reducers.js
 **/